export default "__VITE_PUBLIC_ASSET__339f86e8__"